module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-8x9-98187c351ae286ae5e64c1c3b19c0fa3.jpg";